import styled from 'styled-components'

export const Wrapper = styled.div`
  position: absolute;
  top: 45%;
  left: 50%;
  margin: -280px 0 0 -280px;
  width: 500px;
  height: 600px;
  padding: 70px;
  box-shadow: 0 0 100px rgba(0, 0, 0, 0.08);

  button {
    width: 100%;
  }

  p {
    color: rgb(204, 204, 204);
    text-align: center;
    font-size: 12px;
    margin-bottom: 0px;
    display: flex;
    justify-content: space-between;
  }

  r {
    color: rgb(0, 0, 0);
    text-align: center;
    margin-top: 16px;
    font-size: 15px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const Logo = styled.div`
  text-align: center;
  cursor: pointer;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 64px;
    margin-right: 8px;
  }

  span {
    vertical-align: text-bottom;
    font-size: 16px;
    text-transform: uppercase;
    display: inline-block;
    font-weight: 700;
    color: @primary-color;
  }
`



// WEBPACK FOOTER //
// ./src/pages/Login/styles.js